import {ClientJS} from "clientjs";
import axios from "axios";
import {BASE_URL, isInProductionMode, KEY_TOKEN, projectUrl} from "../Config/SharedConfig";
import Cookies from "universal-cookie";
import {AxiosInstance} from "axios";
import packageJson from '../../package.json'


const PATH = {
    AUTH_LOGIN_PHONE: '/v1/api/user/login',
    AUTH_LOGIN_VERIFY: '/v1/api/user/verify',
    AUTH_LOGIN_NAME: '/api/auth/login/name',

    STORE_BASE_PATH: '/v1/api/store',
    STORE_CREATE: '/v1/api/store',

    CATEGORY_BASE_PATH: 'v1/api/category',

    PRODUCT_LIST: '/v1/api/product',

    THEME_BASE_PATH: '/v1/api/theme',

    GUILD_BASE_PATH: '/v1/api/guild',

    MAP_BASE_PATH: '/v1/api/map',

    ADDRESS_BASE_PATH: '/v1/api/address',

    FILE_BASE_PATH: '/v1/api/file',

    SOCIAL_BASE_PATH: '/v1/api/l',

    USER_BASE_PATH: '/v1/api/user',
}
const cookies = new Cookies()

let token = cookies.get(KEY_TOKEN)

const axiosCall = (method, path, data, progressCallback) => {
    return getInstance().request({
        method: method,
        url: path,
        data: data,
        onUploadProgress: progressCallback,
    });
}

const setAuthToken = function (t) {
    const threeMonthFromNow = new Date();
    threeMonthFromNow.setMonth(threeMonthFromNow.getMonth() + 3);
    cookies.set(KEY_TOKEN, t, {
        expires: threeMonthFromNow,
        path: '/',
        domain: isInProductionMode ? `.${projectUrl}` : undefined,
    })
    token = t
}

const getAuthToken = function (): string {
    return token
}

const getInstance = function (): AxiosInstance {
    return axios.create({
        baseURL: BASE_URL,
        headers: {
            "Authorization": `Bearer ${getAuthToken()}`,
        }
    })
}

const request = {
    delete: url => {
        return axiosCall("delete", url, null)
    },
    post: (url, body, config) => {
        return axiosCall("post", url, body, config)
    },
    get: url => {
        return axiosCall("get", url, null)
    },
    patch: (url, body) => {
        return axiosCall("patch", url, body)
    },
}

const Auth = {
    loginByPhone: phone => {
        return request.post(PATH.AUTH_LOGIN_PHONE, {
            phoneNumber: phone,
        });
    },
    verify: (code, passport) => {
        const client = new ClientJS()
        return request.post(PATH.AUTH_LOGIN_VERIFY, {
            code: code,
            passport: passport,
            deviceFingerprint: client.getFingerprint().toString(),
            appVersion: packageJson.version
        });
    },
    updateName: (firstName, lastName) => {
        return request.patch(PATH.AUTH_LOGIN_NAME, {
            firstName: firstName,
            lastName: lastName,
        });
    },
}
const Store = {
    create: (username) => {
        return request.post(PATH.STORE_CREATE, {
            username: username,
        });
    },
    getByUsername: username => {
        return request.get(PATH.STORE_BASE_PATH + "/".concat(username));
    },
    getInfo: storeUsername => {
        return request.get(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/info'));
    },
    getSplash: storeUsername => {
        const url = `${PATH.STORE_BASE_PATH}/splash`
        return request.post(url, {
            username : storeUsername
        })
    },
    getMe: () => {
        return request.get(PATH.STORE_BASE_PATH + "/splash/me");
    },
    getGallery: storeUsername => {
        return request.get(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/gallery'));
    },
    getIsOwner: storeUsername => {
        return request.get(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/owner'));
    },
    getSocialListForUser: (storeUsername) => {
        const url = `${PATH.STORE_BASE_PATH}/${storeUsername}/social`;
        return request.get(url);
    },

    updateTheme: (storeUsername, themeCode) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/theme'), {value: themeCode});
    },
    updateListType: (storeUsername, listType) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/list'), {value: listType});
    },
    updateUsername: (storeUsername, username) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/username'), {value: username});
    },
    updateTitle: (storeUsername, title) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/title'), {value: title});
    },
    updateSlogan: (storeUsername, slogan) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/slogan'), {value: slogan});
    },
    updateBiography: (storeUsername, biography) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/bio'), {value: biography});
    },
    updateAddress: (storeUsername, address) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/address/attach'), {value: address});
    },
    updateGuild: (storeUsername, guild) => {
        return request.patch(PATH.STORE_BASE_PATH + "/".concat(storeUsername).concat('/guild'), {value: guild});
    },
}
const Category = {
    getList: storeUsername => {
        return request.get(PATH.CATEGORY_BASE_PATH + "/".concat(storeUsername));
    },
    getListPanel: storeUsername => {
        return request.get(PATH.CATEGORY_BASE_PATH + "/".concat(storeUsername).concat("/panel"));
    },
    create: (storeUsername, title) => {
        // return request.post(PATH.CATEGORY_BASE_PATH + "/".concat(storeUsername), {
        return request.post(`${PATH.CATEGORY_BASE_PATH}/${storeUsername}`, {
            title: title,
        });
    },
    delete: (categoryCode) => {
        return request.delete(PATH.CATEGORY_BASE_PATH + "/".concat(categoryCode));
    },
    update: (categoryCode, title) => {
        return request.patch(PATH.CATEGORY_BASE_PATH + "/".concat(categoryCode).concat("/title"), {
            value: title
        });
    },
    updateStatus: (categoryCode) => {
        return request.patch(PATH.CATEGORY_BASE_PATH + "/".concat(categoryCode).concat("/status"));
    },
    updateSorting: (categoryList) => {
        return request.patch(PATH.CATEGORY_BASE_PATH + "/sort", {
            categories: categoryList
        });
    },
}
const Product = {
    getList: (categoryCode, storeUsername, pageNumber = 1, limit = 10) => {
        const url = `${PATH.PRODUCT_LIST}/${storeUsername}/${categoryCode}?page=${pageNumber}&limit=${limit}`;
        return request.get(url);
    },
    getListPanel: storeUsername => {
        return request.get(`${PATH.PRODUCT_LIST}/${storeUsername}/panel`);
    },
    getListForQuickEdit: (categoryCode, storeUsername, pageNumber = 1, limit = 40) => {
        const url = `${PATH.PRODUCT_LIST}/quick/${storeUsername}/${categoryCode}?page=${pageNumber}&limit=${limit}`;
        return request.get(url);
    },
    setListOfQuickEdit: (products, storeUsername) => {
        return request.patch(PATH.PRODUCT_LIST + "/quick/".concat(storeUsername), products);
    },
    getProduct: code => {
        return request.get(`${PATH.PRODUCT_LIST}/${code}`);
    },
    getProductEdit: code => {
        return request.get(PATH.PRODUCT_LIST + "/".concat(code) + "/edit");
    },
    create: (storeUsername, data) => {
        return request.post(PATH.PRODUCT_LIST + "/".concat(storeUsername) + "/create", data);
    },
    edit: (code, data) => {
        return request.patch(PATH.PRODUCT_LIST + "/".concat(code), data);
    },
    delete: (code) => {
        return request.delete(PATH.PRODUCT_LIST + "/".concat(code));
    },
    updateIsActive: (code) => {
        return request.patch(PATH.PRODUCT_LIST + "/".concat(code).concat("/available"));
    },
    updateIsForShow: (code) => {
        return request.patch(PATH.PRODUCT_LIST + "/".concat(code).concat("/isforshow"));
    },
    updateSorting: (productList) => {
        return request.patch(`${PATH.PRODUCT_LIST}/sort`, {
            products: productList
        });
    },

    getEditSubs: productCode => {
        return request.get(PATH.PRODUCT_LIST + "/".concat(productCode) + '/edit/subs');
    },
    createSubgroup: (productCode, data) => {
        return request.post(PATH.PRODUCT_LIST + "/".concat(productCode) + '/subgroup', data);
    },
    patchSubgroupTitle: (productCode, value) => {
        return request.patch(PATH.PRODUCT_LIST + "/".concat(productCode) + '/title-subgroup', {value: value});
    },
    getFiles: (productCode) => {
        return request.get(PATH.PRODUCT_LIST + "/".concat(productCode) + '/gallery');
    },

}
const Theme = {
    getList: () => {
        return request.get(PATH.THEME_BASE_PATH);
    },
}
const Guild = {
    getList: () => {
        return request.get(PATH.GUILD_BASE_PATH);
    },
}
const Map = {
    getInfo: (lat, long) => {
        return request.post(PATH.MAP_BASE_PATH.concat('/info'), {latitude: lat, longitude: long});
    },
}
const Address = {
    create: (data) => {
        return request.post(PATH.ADDRESS_BASE_PATH, data);
    },
    list: () => {
        return request.get(PATH.ADDRESS_BASE_PATH);
    },
    getInfo: addressCode => {
        return request.get(PATH.ADDRESS_BASE_PATH + "/".concat(addressCode));
    },
    delete: addressCode => {
        return request.delete(PATH.ADDRESS_BASE_PATH + "/".concat(addressCode));
    },
}
const File = {
    uploadProductGallery: (productCode, file, config) => {
        const url = `${PATH.FILE_BASE_PATH}/upload/product/${productCode}`;
        return request.post(url, file, config);
    },
    uploadStoreGallery: (storeUsername, file, config) => {
        const url = `${PATH.FILE_BASE_PATH}/upload/store/${storeUsername}`;
        return request.post(url, file, config);
    },
    delete: (code) => {
        return request.delete(`${PATH.FILE_BASE_PATH}/${code}`);
    },
    setDefault: (code) => {
        const url = `${PATH.FILE_BASE_PATH}/${code}/default`;
        return request.patch(url);
    },
}
const SocialMedia = {
    getPatterns: () => {
        return request.get(PATH.SOCIAL_BASE_PATH.concat('/static/patterns'));
    },
    getList: (storeUsername) => {
        return request.get(PATH.SOCIAL_BASE_PATH + "/".concat(storeUsername).concat('/social'));
    },
    getListForUser: (storeUsername) => {
        return request.get(PATH.SOCIAL_BASE_PATH + "/client/".concat(storeUsername).concat('/social'));
    },
    create: (storeUsername, data) => {
        return request.post(PATH.SOCIAL_BASE_PATH + "/".concat(storeUsername).concat('/social'), data);
    },
    edit: (storeUsername, socialCode, data) => {
        return request.patch(PATH.SOCIAL_BASE_PATH + "/".concat(storeUsername).concat('/social/').concat(socialCode), {value: data});
    },
    delete: (storeUsername, socialCode) => {
        return request.delete(PATH.SOCIAL_BASE_PATH + "/".concat(storeUsername).concat('/social/').concat(socialCode));
    },
}
const User = {
    get: () => {
        return request.get(PATH.USER_BASE_PATH + "/me");
    },
    logout: () => {
        return request.get(PATH.USER_BASE_PATH + "/logout");
    },
    updateName: (firstName, lastName) => {
        return request.patch(PATH.USER_BASE_PATH + "/name", {
            firstName: firstName,
            lastName: lastName,
        });
    },
}


export default {
    getInstance,
    setAuthToken,
    getAuthToken,
    Auth,
    Store,
    Category,
    Product,
    Theme,
    Guild,
    Map,
    Address,
    File,
    SocialMedia,
    User
}